import { Col, Space, Typography } from 'antd';
import { path } from 'ramda';
import React from 'react';
import { Components } from '@fasstech/flexiget';
const { Text } = Typography;

const DocumentDates = ({ renderDate, element }) => {
  return (
    <>
      <Col />
      <Col>
        <Space>
          • {/* Separator */}
          <Components.Tooltip
            title="Date de création"
          >
            <Text type="secondary">
              {renderDate(path(['dates', 'creation'], element))}
            </Text>
          </Components.Tooltip>
          <Components.Tooltip
            title="Date de modification"
          >
            <Text type="secondary">
              {renderDate(path(['dates', 'lastUpdate'], element))}
            </Text>
          </Components.Tooltip>
        </Space>
      </Col>
    </>
  );
};

export default DocumentDates;
